'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/contexts/AuthContext'
import { ActiveProjectProvider } from '@/contexts/ActiveProjectContext'
import EulaGate from '@/components/EulaGate'
import { useState } from 'react'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        refetchOnWindowFocus: false,
      },
    },
  }))

  return (
    <AuthProvider>
      <ActiveProjectProvider>
        <QueryClientProvider client={queryClient}>
          {children}
          <EulaGate />
        </QueryClientProvider>
      </ActiveProjectProvider>
    </AuthProvider>
  )
}
